module.exports = __webpack_public_path__ + "static/img02-e23f6853d5f7d6decefd7e41d60c2db4.png";